<div class="forgot-wrapper">
  <h3 class="header">PASSWORD RESET</h3>
  <hr>
  <form (submit)="onSend()" #f="ngForm" [ngStyle]="{opacity: whileUpdating ? 0.2 : 1}">
    <p>
      Please enter your email, and a password reset email will be delivered to you shortly:
    </p>
    <div class="form-group">
      <label for="email">Email address</label>
      <input type="email" style="width: 80%; border-radius: 8px;" name="email"
             id="email" aria-describedby="emailHelp" placeholder="Enter email" [(ngModel)]="email" required email>
    </div>
    <button class="submit" type="submit" (click)="email=''">Cancel</button>
    <button class="submit" type="submit" [disabled]="!f.valid">Send Reset Email</button>
  </form>
</div>

